
import store from "@km/store";
import {
    StockLogoCategory,
    StockLogoPoolEntry,
    StockLogoStore
} from "@k/js/stocklogos/stocklogoController";
import {StockLogoFromBackend} from "@k/js/selectableObjects"
import {resourcemanagerVue} from "@km/js/resourceManagerVue";

export const StockLogoStoreWrapper:StockLogoStore = {
    getOriginalSVG(stockLogoID): Promise<StockLogoFromBackend> {
        return store.dispatch("StockLogoStore/getOriginalSVG", stockLogoID)
    }, getVorschauSVG(stockLogoID): Promise<string> {
        return store.dispatch("StockLogoStore/getVorschauSVG", stockLogoID)
    },
    getPatternCategories(): StockLogoCategory[] {
        return store.getters["StockLogoStore/getPatternCategories"];
    }, getStockLogoCategories(): StockLogoCategory[] {
        return store.getters["StockLogoStore/getStockLogoCategories"];
    },
    loadLogos(language): void {
        store.dispatch("StockLogoStore/loadStockLogos", language)
    },
    getStockLogoCategory(categoryName: string): StockLogoCategory | null {
        return store.getters["StockLogoStore/getCategory"](categoryName);
    }, getCategoryForStockLogoID(stockLogoID): StockLogoCategory | null {
        return store.getters["StockLogoStore/getCategoryForStockLogoID"](stockLogoID);
    }, getStockLogo(id): StockLogoPoolEntry | null {
        return store.getters["StockLogoStore/getLogo"](id);
    }, getStockLogoSubCategories(categoryName: string): StockLogoCategory[] {
        return store.getters["StockLogoStore/getSubCategories"](categoryName);
    },
    getStockLogoAndPatternCategories(): StockLogoCategory[] {
        return store.getters["StockLogoStore/getCategories"]
    },
    setStockLogoCategories(categories:StockLogoCategory[]) {
        store.commit("StockLogoStore/SETSTOCKLOGOCATEGORIES", categories)
        resourcemanagerVue.registerLoadedResourceWithoutData("stocklogosloaded");
    },
    getLocalizedName(stocklogoID): string {
        return store.getters["StockLogoStore/getLogo"](stocklogoID)?.nameLocalized || "";
    }
}
